import { Container} from 'react-bootstrap';
import PartnerData from '../partner_data';
import { useParams } from 'react-router-dom';
import React from 'react';
import ProductDescription from './../components/Product_description'


const Brand_details = () => {
    const params = useParams();
    const brand = PartnerData.find(brand => brand.url === params.id);
    const type = brand.products.find(type => type.type_url === params.type)
    return (
        <Container>
            <div className="min-h-full items-center sm:px-6 lg:px-8 w-full">
                <ProductDescription partner_url={brand.partner_url} image={brand.image} image_width={brand.image_width} image_height={brand.image_height} className={brand.className} description={brand.description}/>
                <div className="pb-2">
                    <div className="pt-5 felx flex-row">
                        <h2 className="anton text-2xl text-left">{type.name}</h2>
                        <p className="text-left pt-2">{type.description}</p>
                        {type.details.map((detail) => (
                            <div>
                                <div className="pt-2 w-full rounded" id="product_details">
                                    <div className="flex items-center justify-center">
                                            <img src={detail.image} alt={detail.alt} style={{display: 'inline-block'}} className="py-2"/>
                                    </div>
                                    <div className="pl-3 ml-5 flex items-center ">
                                        <div>
                                            <h3 className="text-left text-xl font-semibold">{detail.name}</h3>
                                            <p className="text-left pt-1  ">{detail.description}</p>
                                            {
                                                detail.sub_descriptions_title ? <h3 className="pt-4 text-md font-semibold">{detail.sub_descriptions_title}</h3> : null
                                            }
                                            <ol className="list-disc">
                                                {
                                                    detail?.sub_descriptions?.map((description) => (
                                                        <li className="py-1">{description}</li>
                                                    ))
                                                }
                                            </ol>
                                            {
                                                detail.table_headers ? 
                                                <div className="pt-4">
                                                <table>
                                                    <tr>
                                                        {
                                                            detail?.table_headers?.map((headers)=>(
                                                                <th className="border-1 border-black px-2 bg-gray-200 text-center py-2">{headers}</th>
                                                            ))
                                                        }
                                                    </tr>
                                                    {
                                                        detail?.table_content?.map((content)=>(
                                                            <tr>
                                                                {content.map((element)=>(
                                                                    <td className="border-1 border-black px-2 text-center">{element}</td>
                                                                ))}
                                                            </tr>
                                                        ))
                                                    }
                                                </table>
                                                </div>
                                                : null
                                            }
                                        </div>
                                    </div>
                                </div>
                                {/* <div></div> */}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default Brand_details
